import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/components/Home';
import ContactTracking from '@/components/ContactTracking';
import EmptyLayout from '@/components/EmptyLayout';

import Login from '@/components/webshop/Login';
import PasswordReset from '@/components/webshop/Password-reset';
import PasswordForgot from '@/components/webshop/Password-forgot';
import Registration from '@/components/webshop/Registration';
import Activate from '@/components/webshop/Activate';
import Addresses from '@/components/webshop/Addresses';
import OrderInfo from '@/components/webshop/Order-info';
import ErrorPage from '@/components/404';
import ProtectionTerms from '@/components/Protection-terms';
import Payments from '@/components/Payments';
import OrderHistory from '@/components/webshop/userOrderHistory/OrderHistory';
import VisitsSearch from '@/components/VisitsSearch';
import Orders from '@/components/OrdersAdmin/Orders';
import OrdersSearch from '@/components/OrdersAdmin/OrdersSearch';
import Blacklist from '@/components/OrdersAdmin/Blacklist';
import Rate from '@/components/Rate';
import Menu from '@/components/webshop/Menu';

Vue.use(Router);

const lang = () => {
  const company = localStorage.company ? JSON.parse(localStorage.company) : null;
  if (company) {
    return localStorage.getItem('lang') || company.defaultLanguage || 'en';
  }
  return localStorage.getItem('lang') || 'en';
};

const router = new Router({
  routes: [
    {
      path: '/id/:resource',
      redirect: `/${lang()}/id/:resource`,
    },
    {
      path: '/payment/:resourceId/:orderId',
      redirect: from => ({
        path: `/${lang()}/payment/:resourceId/:orderId`,
        query: from.query,
      }),
    },
    {
      path: '/reset/:resourceId/:id',
      redirect: from => ({
        path: `/${lang()}/reset/:resourceId/:id`,
        query: from.query,
      }),
    },
    {
      path: '/activate/:resourceId/:hash',
      redirect: from => ({
        path: `/${lang()}/activate/:resourceId/:hash`,
        query: from.query,
      }),
    },
    {
      path: '/contact-tracking/:resourceId?/:tableName?',
      redirect: from => ({
        path: `/${lang()}/contact-tracking/:resourceId?/:tableName?`,
        query: from.query,
      }),
    },
    {
      path: '/menu',
      redirect: from => ({
        path: `/${lang()}/menu`,
        query: from.query,
      }),
    },
    {
      path: '/',
      redirect: `/${lang()}`,
    },
    {
      path: '/:lang',
      component: EmptyLayout,
      children: [
        {
          path: '',
          component: Home,
          props: true,
          name: 'webShop',
        },
        {
          path: 'contact-tracking/:resourceId?/:tableName?',
          component: ContactTracking,
          props: true,
          name: 'ContactTracking',
        },
        {
          path: 'rate/:resourceId/:hash',
          component: Rate,
          props: true,
          name: 'Rate',
        },
        {
          path: 'visits',
          component: VisitsSearch,
          name: 'VisitsSearch',
        },
        {
          path: 'orders',
          component: Orders,
          children: [
            {
              path: '',
              redirect: {
                name: 'ordersSearch',
              },
            },
            {
              path: 'search',
              component: OrdersSearch,
              name: 'ordersSearch',
            },
            {
              path: 'blacklist',
              component: Blacklist,
              name: 'blacklist',
            },
          ],
        },
        {
          path: 'addresses',
          component: Addresses,
          name: 'addresses',
        },
        {
          path: 'order-info',
          component: OrderInfo,
          name: 'orderInfo',
        },
        {
          path: 'login',
          component: Login,
          name: 'login',
        },
        {
          path: 'reset',
          component: EmptyLayout,
          children: [
            {
              path: '',
              name: 'forgotPassword',
              component: PasswordForgot,
            },
            {
              path: ':resourceId/:id',
              name: 'passwordReset',
              component: PasswordReset,
            },
          ],
        },
        {
          path: 'registration',
          component: Registration,
          name: 'registration',
        },
        {
          path: 'activate',
          component: EmptyLayout,
          children: [
            {
              path: '',
              redirect: { name: 'login' },
            },
            {
              path: ':resourceId/:hash',
              component: Activate,
              name: 'activate',
            },
          ],
        },
        {
          path: 'terms-and-Conditions',
          name: 'terms',
          component: ProtectionTerms,
        },
        {
          path: 'data-protection-policy',
          name: 'data-protection',
          component: ProtectionTerms,
        },
        {
          path: 'payment',
          component: EmptyLayout,
          children: [
            {
              path: '',
              redirect: { path: `/${lang()}` },
            },
            {
              path: ':resourceId/:orderId',
              name: 'payment',
              component: Payments,
            },
          ],
        },
        {
          path: 'id',
          component: EmptyLayout,
          children: [
            {
              path: '',
              redirect: { name: 'webShop' },
            },
            {
              path: ':resource',
              component: Home,
              name: 'resourceSet',
            },
          ],
        },
        {
          path: 'order-history',
          component: EmptyLayout,
          children: [
            {
              path: '',
              component: OrderHistory,
              name: 'orderHistory',
            },
          ],
        },
        {
          path: 'menu',
          component: EmptyLayout,
          children: [
            {
              path: '',
              component: Menu,
              name: 'menu',
            },
          ],
        },
        {
          path: ':resource',
          component: Home,
          name: 'resourceSet2',
        },
        {
          path: '/*',
          name: '404',
          component: ErrorPage,
        },
      ],
    },
  ],
  scrollBehavior: () =>
    ({ x: 0, y: 0 }),
  mode: 'history',
});

// eslint-disable-next-line no-unused-vars
// router.beforeEach((to, from, next) => {
//   window.Intercom('update');
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js